import React from 'react';
import ModelsHeader from './ModelsHeader';
import ModelsContent from './ModelsContent';
import { useDateNavigation, useModelActions } from './hooks';

interface ModelsCardProps {
  tabId?: string;
}

const ModelsCard: React.FC<ModelsCardProps> = ({ tabId }) => {
  // Custom hooks for managing state and actions
  const dateNavigation = useDateNavigation(undefined, undefined, tabId);
  const modelActions = useModelActions();

  return (
    <div
      className="h-full bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm"
      data-card-container
    >
      <div className="h-full flex flex-col">
        {/* Header */}
        <ModelsHeader onResetAll={modelActions.handleResetAll} />

        {/* Content */}
        <ModelsContent
          currentDateIndex={dateNavigation.currentDateIndex}
          onPrevious={dateNavigation.handlePreviousDate}
          onNext={dateNavigation.handleNextDate}
          isAtFirstDate={dateNavigation.isAtFirstDate}
          isAtLastDate={dateNavigation.isAtLastDate}
          currentDates={dateNavigation.currentDates}
          models={modelActions.state.availableModels}
          onSelectionChange={modelActions.handleSelectionChange}
          onModelToggle={modelActions.handleModelToggle}
          loading={modelActions.state.loading}
          error={modelActions.state.error}
        />
      </div>
    </div>
  );
};

export default ModelsCard;
